import { useMutation } from "react-query";

import { NOTIFICATIONS } from "~/constans/notifications";
import { logoutIvideon } from "~/pages/Ivideon/requests/logoutIvideon";
import { useAddNotificationMutation } from "~/schemas/generated/graphql";

export default function useLogoutIvideon() {
  const [addNotificationMutation] = useAddNotificationMutation({});

  return useMutation({
    mutationFn: (dealerId: string) => logoutIvideon(dealerId),
    onError: (error) => {
      addNotificationMutation({
        variables: {
          type: NOTIFICATIONS.info,
          content: (error as Error)["message"] ?? "Авторизация не найдена",
        },
      });
    },
  });
}
